import script from "./QuizTileComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizTileComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuizTileComponent.vue?vue&type=style&index=0&id=631c1880&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631c1880"]])

export default __exports__